import { Link } from "@tanstack/react-router";
import { useMrPandaZone } from "@/hooks/storefront/use-mrpanda-zone";
import { cn } from "@/lib/utils";
import { formatPrice } from "@/lib/format";

/** 🚐 Μπάρα «Δωρεάν αποστολή στον χώρο σου» — μόνο για περιοχές Παράδοσης MrPanda. */
export function MrPandaDeliveryBar({ className }: { className?: string }) {
  const zone = useMrPandaZone();
  const hasExactZone = zone?.serviceable && zone.freeOver != null;

  return (
    <section className={cn("px-2 pt-3 md:px-4", className)}>
      <Link
        to="/shipping-methods"
        aria-label="Δες τους τρόπους αποστολής"
        className="xmas-bar flex flex-wrap items-center justify-center gap-x-3 gap-y-1 overflow-hidden rounded-3xl border-2 border-dashed border-primary/40 px-4 py-3 text-center shadow-sm transition-transform hover:scale-[1.01]"
      >
        <span aria-hidden className="animate-bob text-2xl">🚐</span>
        <p className="text-sm font-extrabold tracking-tight text-foreground sm:text-base">
          {hasExactZone ? (
            <>
              Είσαι στην περιοχή μας! Δωρεάν αποστολή στον χώρο σου με αγορές άνω των{" "}
              <span className="text-price">{formatPrice(zone.freeOver)}</span> 🐼
            </>
          ) : (
            <>
              Θεσσαλονίκη: Παράδοση MrPanda και δωρεάν μεταφορικά από{" "}
              <span className="text-price">{formatPrice(25)}</span>, ανάλογα με την περιοχή 🐼
            </>
          )}
        </p>
        <span aria-hidden className="text-lg">📦✨</span>
      </Link>
    </section>
  );
}

/** 🚐 Παιχνιδιάρικο badge δίπλα στην τιμή του προϊόντος. */
export function MrPandaDeliveryBadge({ className }: { className?: string }) {
  const zone = useMrPandaZone();
  const hasExactZone = zone?.serviceable && zone.freeOver != null;

  return (
    <span
      className={cn(
        "inline-flex max-w-[15rem] items-center gap-1.5 rounded-full border-2 border-dashed border-primary/50 bg-primary/10 px-3 py-1.5 text-xs font-extrabold leading-tight text-foreground",
        className,
      )}
    >
      <span aria-hidden className="animate-bob text-base">🚐</span>
      {hasExactZone ? (
        <>
          Δωρεάν αποστολή στον χώρο σου άνω των{" "}
          <span className="text-price">{formatPrice(zone.freeOver)}</span>
        </>
      ) : (
        <>
          Θεσσαλονίκη: δωρεάν μεταφορικά από{" "}
          <span className="text-price">{formatPrice(25)}</span>
        </>
      )}
    </span>
  );
}
